import { PageHeader } from "ant-design-vue";
const { ...other } = PageHeader;
const YwPageHeader = {
	...other,
	name: "YwPageHeader",
};

YwPageHeader.install = function (Vue) {
	Vue.component(YwPageHeader.name, PageHeader);
};

export default YwPageHeader;
